import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import numeral from 'numeral';
import { css, cx } from '@bd/bdui-styles/emotion';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import LightBox from '@bd/bdui-lightbox';
import Swipeable from './Swipeable';
import HomeMapModal from './HomeMapModal';
import { colors, typography } from '../styles';

const styles = css`
  width: 100%;
  background-color: white;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.13);
  .HomeCard_images {
    width: 100%;
    height: 187px;
    position: relative;
    z-index: 0;
    @media (min-width: 461px) and (max-width: 619.98px) {
      height: 220px;
    }
    @media (min-width: 851px) and (max-width: 991.98px) {
      height: 220px;
    }
    @media (min-width: 1700px) {
      height: 220px;
    }
  }
  .HomeCard_imageLink {
    display: block;
    width: 100%;
    height: 100%;
  }
  .HomeCard_imageWrapper {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    overflow: hidden;
  }
  .HomeCard_image {
    position: absolute;
    z-index: 0;
    top: -100%;
    right: -100%;
    bottom: -100%;
    left: -100%;
    min-width: 100%;
    min-height: 100%;
    margin: auto;
    max-width: 133%;
    @supports (object-fit: cover) and (object-position: center center) {
      top: 0;
      left: 0;
      right: auto;
      bottom: auto;
      margin: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center center;
    }
  }
  .HomeCard_image-active {
    z-index: 1;
  }
  .HomeCard_imageControls {
    height: 14px;
    position: absolute;
    z-index: 2;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 0 9px;
  }
  .HomeCard_imageControl {
    opacity: .8;
    width: 8px;
    height: 14px;
    padding: 0;
    border: none;
    cursor: pointer;
    background-color: transparent;
    background-repeat: no-repeat;
  }
  .HomeCard_imageControl-next {
    background-image: url('/images/i-arrow-right-white.svg');
  }
  .HomeCard_imageControl-prev {
    background-image: url('/images/i-arrow-left-white.svg');
  }
  .HomeCard_status {
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    padding: 21px 18px 12px;
    margin: 0;
    background-image: linear-gradient(to bottom, transparent, #1A1A17);
    z-index: 2;
    color: #FFFFFF;
    font-size: 13px;
    font-weight: 800;
    letter-spacing: 1.5px;
    line-height: 1;
    text-transform: uppercase;
  }
  .HomeCard_content {
    padding: 16px 17px;
    position: relative;
  }
  .HomeCard_contentInner {
    position: relative;
  }
  .HomeCard_addressWrapper {
    display: flex;
    padding-right: 40px;
  }
  .HomeCard_address {
    font-weight: 700;
    font-size: 16px;
    color: #000000;
    letter-spacing: 0;
    a {
      color: #000000;
      &:hover {
        text-decoration: none;
      }
    }
  }
  .HomeCard_mapModal {
    position: absolute;
    top: -2px;
    right: -2px;
  }
  .HomeMapModal_openButton {
    background: none;
    border: none;
    padding: 2px;
    cursor: pointer;
  }
  .HomeMapModal_openButtonInner {
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 11px;
    font-weight: bold;
    line-height: 1.4;
    color: black;
    img {
      width: 15px;
      height: auto;
    }
  }
  .HomeCard_addressArea {
    display: block;
    font-weight: 600;
    font-size: 12px;
    color: #000000;
    letter-spacing: 1.7px;
    text-transform: uppercase;
  }
  .HomeCard_contentMapButton {
    margin-left: auto;
    display: block;
    width: 31px;
    height: 40px;
    padding: 21px 0 0 0;
    background-image: url('/images/i-map-pin.svg');
    background-size: 15px auto;
    background-repeat: no-repeat;
    background-position: center top;
    text-align: center;
    color: black;
    font-size: 11px;
    font-weight: bold;
    cursor: pointer;
  }
  .HomeCard_linkRow {
    display: flex;
    border-top: 1px solid #ECECEC;
    border-bottom: 1px solid #ECECEC;
    padding:0;
  }
  .HomeCard_links {
    width: 65%;
    padding: 5px 0 5px 0;
    font-size: 13px;
    font-weight: bold;
    line-height: 1.5;
    color: ${colors.color5};
    a {
      display: block;
      color: ${colors.color5};
      &:hover {
        text-decoration: none;
      }
    }
  }
  .HomeCard_priceWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0 10px;
    width: 35%;
    min-height: 52px;
    text-align: center;
    border-left: solid 1px #ECECEC;
  }
  .HomeCard_priceValue {
    font-size: 14px;
    font-weight: 700;
    line-height: 1;
    color: #000000;
  }
  .Label {
    font-weight: 300;
    font-size: 14px;
    color: #000000;
    letter-spacing: 0;
  }
  .HomeCard_bottom {
    display: flex;
    align-items: center;
    padding-top: 13px;
    flex-wrap:wrap;
  }
  .HomeCard_specs {
    display: flex;
    justify-content: space-around;
    flex-grow:1;
  }
  .HomeCard_spec {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: .5px;
    text-transform: uppercase;
    line-height: 1;
    text-align: center;
    color: #000;
    &:not(:last-child) {
      margin-right: 17px;
    }
  }
  .HomeCard_specValue {
    display: block;
    font-weight: 200;
    font-size: 22px;
    color: #000000;
    letter-spacing: 0;
    text-align: center;
    padding-bottom: 6px;
  }
  .HomeCard_detailButton {
    text-transform: none;
    letter-spacing: 0;
    font-family: ${typography.SansSerif};
    padding: 10px 15px;
    font-size: 15px;
    flex-shrink: 0;
    flex-grow:1;
    margin-top: 15px;
  }
  .HomeCard_lightBoxWrapper{
    position: absolute;
    top: -32px;
    right: 10px;
    z-index: 2;
  }
  .HomeCard_expand{
    height:17px;
    width: 17px;
    transition: all .2s ease-out;
    &:hover{
      height: 18px;
      width: 18px;
      transition: all .2s ease-out;
    }
  }
`;
const lightboxStyles = css`
  height: 100%;
  width: auto;
`;

class HomeCard extends React.Component {
  constructor(props) {
    super(props);

    const lazyLoadLog = get(props.home, 'photos', []).map((photo, index) => (
      index !== 0
    ));

    this.state = {
      activeIndex: 0,
      lazyLoadLog,
    };
  }

  changeImage(index) {
    const { lazyLoadLog } = this.state;
    const newLazyLoadLog = lazyLoadLog;
    if (newLazyLoadLog[index]) {
      newLazyLoadLog[index] = false;
    }

    this.setState({
      activeIndex: index,
      lazyLoadLog: newLazyLoadLog,
    });
  }

  prevImage(totalNumberOfImages) {
    const { activeIndex } = this.state;
    const finalImageIndex = totalNumberOfImages - 1;
    const nextIndex = activeIndex === 0 ? finalImageIndex : activeIndex - 1;

    this.changeImage(nextIndex);
  }

  nextImage(totalNumberOfImages) {
    const { activeIndex } = this.state;
    const finalImageIndex = totalNumberOfImages - 1;
    const nextIndex = activeIndex === finalImageIndex ? 0 : activeIndex + 1;

    this.changeImage(nextIndex);
  }

  render() {
    const { activeIndex, lazyLoadLog } = this.state;
    const { className, community, home, widget } = this.props;
    const homeStreetAddress = get(home, 'address.streetAddress');
    const homePrice = get(home, 'price');
    const homeStatus = get(home, 'status');
    const homeId = `home-card-${home._id}`;
    const homeImages = get(home, 'photos', []);
    const numberOfHomeImages = homeImages.length;
    const approvedBuilder = widget.builder.filter(item => item._id === home.custom_builder);
    return (
      <div className={cx(styles, className)} role="group" aria-labelledby={homeId}>
        <Swipeable
          className="HomeCard_images"
          onSwipeLeft={() => this.nextImage(numberOfHomeImages)}
          onSwipeRight={() => this.prevImage(numberOfHomeImages)}
        >
          <Link
            className="HomeCard_imageLink"
            name="home-detail"
            home={home}
            aria-label={`visit ${homeStreetAddress}`}
          >
            {
              numberOfHomeImages > 1 &&
              <div className="HomeCard_imageControls">
                <button
                  className="HomeCard_imageControl HomeCard_imageControl-prev"
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    this.prevImage(numberOfHomeImages);
                  }}
                />
                <button
                  className="HomeCard_imageControl HomeCard_imageControl-next"
                  type="button"
                  onClick={e => {
                    e.preventDefault();
                    this.nextImage(numberOfHomeImages);
                  }}
                />
              </div>
            }
            <div className="HomeCard_imageWrapper">
              {
                homeImages.map((photo, index) => {
                  const imageSrc = get(photo, 'contentUrl');
                  const imageThumbnail = buildThumbnailUrl(imageSrc, { width: 350, height: 350 });
                  const shouldLazyLoad = !lazyLoadLog[index];
                  return (
                    <img
                      className={[
                        'HomeCard_image',
                        index === activeIndex ? 'HomeCard_image-active' : '',
                      ].join(' ').trim()}
                      src={shouldLazyLoad ? imageThumbnail : undefined}
                      data-src={shouldLazyLoad ? undefined : imageThumbnail}
                      aria-hidden={index !== activeIndex}
                      alt={get(photo, 'name', '')}
                      key={imageSrc}
                    />
                  );
                })
              }
              {homeImages.length === 0 &&
                <img
                  className="HomeCard_image"
                  src="/images/noimage.jpg"
                  alt={get(home, 'name')}
                />
              }
            </div>
            {
              homeStatus &&
              <p className="HomeCard_status">{homeStatus}</p>
            }
          </Link>
        </Swipeable>
        <div className="HomeCard_content">
          <div className="HomeCard_lightBoxWrapper">
            {
              homeImages.length > 0 &&
              <LightBox className={lightboxStyles} items={homeImages}>
                <img className="HomeCard_expand" src="/images/i-expand.svg" alt="Expand" />
              </LightBox>
            }
          </div>
          <div className="HomeCard_contentInner">
            <div className="HomeCard_addressWrapper">
              <h4 className="HomeCard_address">
                <Link name="home-detail" home={home}>
                  <span id={homeId}>{`${homeStreetAddress} `}</span>
                  <span className="HomeCard_addressArea">
                    {`${get(home, 'address.addressLocality')}`}
                  </span>
                </Link>
              </h4>
              <HomeMapModal className="HomeCard_mapModal" homeId={home._id}>
                <span className="HomeMapModal_openButtonInner">
                  <img src="/images/i-map-pin.svg" alt="" />
                  <span className="sr-only">{`open ${homeStreetAddress} on `}</span>
                </span>
              </HomeMapModal>
            </div>
            <div className="HomeCard_linkRow">
              <div className="HomeCard_links">
                {
                  get(community, 'name') &&
                  <Link name="community-detail" community={community}><span className="Label">Neighborhood:</span> {community.name}</Link>
                }
                {approvedBuilder.length > 0 &&
                  <div><span className="Label">Builder:</span> {approvedBuilder[0].name}</div>
                }
              </div>
              {
                (homePrice || homeStatus !== 'Sold') &&
                <div className="HomeCard_priceWrapper">
                  {
                    homePrice &&
                    <span className="HomeCard_priceValue">{numeral(homePrice).format('$0,0')}</span>
                  }
                  {
                    !homePrice &&
                    <span className="HomeCard_priceValue">Call for pricing</span>
                  }
                </div>
              }
            </div>
            <div className="HomeCard_bottom">
              <div className="HomeCard_specs">
                {
                  get(home, 'beds') &&
                  <div className="HomeCard_spec">
                    <span className="HomeCard_specValue">{get(home, 'beds')} </span>
                    Beds
                  </div>
                }
                {
                  get(home, 'bathsFull') &&
                  <div className="HomeCard_spec">
                    <span className="HomeCard_specValue">{get(home, 'bathsFull')}{get(home, 'bathsHalf', 0) > 0 && '.5'} </span>
                    Baths
                  </div>
                }
                {
                  get(home, 'sqft') &&
                  <div className="HomeCard_spec">
                    <span className="HomeCard_specValue">{numeral(get(home, 'sqft')).format('0,0')} </span>
                    Sq Ft
                  </div>
                }
                {
                  get(home, 'garages') &&
                  <div className="HomeCard_spec">
                    <span className="HomeCard_specValue">{numeral(get(home, 'garages')).format('0,0')} </span>
                    Garages
                  </div>
                }
              </div>
              <Link className="Btn Gold HomeCard_detailButton" name="home-detail" home={home}>
                View Details
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }
}


HomeCard.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object,
  home: PropTypes.object.isRequired,
  widget: PropTypes.object.isRequired,
};

HomeCard.defaultProps = {
  className: undefined,
  community: undefined,
  plan: undefined,
};

export default withData(
  {
    home: true,
    plan: true,
    community: true,
    widget: 'approved_builders',
  },
  {
    required: {
      home: true,
    },
  },
)(HomeCard);



// WEBPACK FOOTER //
// ./src/components/HomeCard.js